export default __webpack_public_path__ + "static/1970_1980-9cc1be5fd1d9458e1bb3c84543f2cc74.mp4";